import React from 'react';
import { Badge } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';

export const policyRuleConfig: EntityRegistryEntry = {
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'IsSystem', 'Disabled', 'Description'],
    listColumns: ({ isStandard }: ColumnOptions) => {
        const columns = [
            {
                key: 'disabled',
                label: 'Status',
                sortable: true,
                render: (entity: any) => {
                    const raw = (entity as any).Disabled;
                    const disabled = typeof raw === 'boolean'
                        ? raw
                        : (typeof raw === 'string'
                            ? raw.toLowerCase() === 'true'
                            : !!raw);
                    return (
                        <Badge
                            variant="light"
                            size="sm"
                            color={disabled ? 'red' : 'green'}
                        >
                            {disabled ? 'Disabled' : 'Active'}
                        </Badge>
                    );
                }
            },
            {
                key: 'description',
                label: 'Description',
                sortable: true,
                render: (entity: any) => entity.Description || 'N/A'
            }
        ];

        if (!isStandard) {
            columns.splice(1, 0, {
                key: 'issystem',
                label: 'Is System',
                sortable: true,
                render: (entity: any) => {
                    const raw = (entity as any).IsSystem;
                    const isSystem = typeof raw === 'boolean'
                        ? raw
                        : (typeof raw === 'string'
                            ? raw.toLowerCase() === 'true'
                            : !!raw);
                    return (
                        <Badge
                            variant="outline"
                            size="sm"
                            color={isSystem ? 'blue' : 'gray'}
                        >
                            {isSystem ? 'Yes' : 'No'}
                        </Badge>
                    );
                }
            });
        }

        return columns;
    }
};
